module.exports = __webpack_public_path__ + "img/logo-icoev-actual-simbolo.2522f094.png";